import {
  enrichedTurnSchema,
  positionedEnrichedTurnSchema,
  type EnrichedTurn,
  type PositionedEnrichedTurn,
} from './schema';

const enrichedTranscriptSchema = enrichedTurnSchema.array();

/** Parse wire or driver JSON into validated enriched transcript turns. */
export function decodeEnrichedTranscript(value: unknown): EnrichedTurn[] {
  const decoded: unknown = typeof value === 'string' ? JSON.parse(value) : value;
  return enrichedTranscriptSchema.parse(decoded);
}

export const enrichedTranscriptDecoder = {
  mapFromDriverValue(value: unknown): EnrichedTurn[] {
    return decodeEnrichedTranscript(value);
  },
};

const positionedEnrichedTranscriptSchema = positionedEnrichedTurnSchema.array();

/** Parse the positioned transcript projection (turns carrying their stored position). */
export function decodePositionedEnrichedTranscript(value: unknown): PositionedEnrichedTurn[] {
  const decoded: unknown = typeof value === 'string' ? JSON.parse(value) : value;
  return positionedEnrichedTranscriptSchema.parse(decoded);
}

export const positionedEnrichedTranscriptDecoder = {
  mapFromDriverValue(value: unknown): PositionedEnrichedTurn[] {
    return decodePositionedEnrichedTranscript(value);
  },
};
